import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import './NavLockedBubble.css';

export const ActivateMark = ({ label }) => (
  <Tooltip title={label}>
    <span
      className="nav-locked-bubble"
      tabIndex={0}
      role="img"
      aria-label={label}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    />
  </Tooltip>
);

ActivateMark.propTypes = {
  label: PropTypes.string.isRequired,
};

const NavLockedBubble = ({
  featureTitle,
  status,
  description,
  hint,
  placement,
}) => {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);
  const placeLeft = placement === 'left';

  const updatePosition = () => {
    const node = anchorRef.current;
    if (!node) {
      return;
    }
    const rect = node.getBoundingClientRect();
    setCoords({
      top: rect.top + rect.height / 2,
      left: placeLeft ? rect.left - 14 : rect.right + 14,
    });
  };

  const show = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    updatePosition();
    setOpen(true);
  };

  const hide = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onMove = () => updatePosition();
    window.addEventListener('resize', onMove);
    window.addEventListener('scroll', onMove, true);
    return () => {
      window.removeEventListener('resize', onMove);
      window.removeEventListener('scroll', onMove, true);
    };
  }, [open, placeLeft]);

  const ariaLabel = [featureTitle, status, description, hint]
    .filter(Boolean)
    .join('. ');

  return (
    <span
      className="nav-locked-bubble-wrap"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      <span
        ref={anchorRef}
        className="nav-locked-bubble"
        tabIndex={0}
        aria-label={ariaLabel}
      />
      {open
        ? ReactDOM.createPortal(
            <div
              className={
                'nav-locked-hover-card' +
                (placeLeft ? ' is-placement-left' : '')
              }
              style={{ top: coords.top, left: coords.left }}
              role="status"
            >
              <p className="nav-locked-hover-card-feature">{featureTitle}</p>
              {status ? (
                <p className="nav-locked-hover-card-status">{status}</p>
              ) : null}
              {description ? (
                <p className="nav-locked-hover-card-copy">{description}</p>
              ) : null}
              {hint ? (
                <p className="nav-locked-hover-card-hint">{hint}</p>
              ) : null}
            </div>,
            document.body
          )
        : null}
    </span>
  );
};

NavLockedBubble.propTypes = {
  featureTitle: PropTypes.string.isRequired,
  status: PropTypes.string,
  description: PropTypes.string,
  hint: PropTypes.string,
  placement: PropTypes.oneOf(['left', 'right']),
};

NavLockedBubble.defaultProps = {
  status: '',
  description: '',
  hint: '',
  placement: 'right',
};

export default NavLockedBubble;



// WEBPACK FOOTER //
// ./src/components/leftnav/NavLockedBubble.js